import React from "react";

/**
 * 車両交代の区切り。「07:50まで8073 → 09:22から2528 → 18:51から1911」。
 *
 * **車号ページと「本日のできごと」で同じ形に描く。** 片方だけ書き方が
 * 違うと、同じ交代が画面によって別のできごとに見える。
 *
 * 車号ページでは、主に走った乗番だけでなく応援に出た先で起きた交代も出す。
 * その車も交代の当事者なので、片側からしか見えないのはおかしい。
 * `is_this_bus` が付いた区間はリンクにせず太字にして、いま見ている車だと示す。
 *
 * @param {object}   change      { segments: [{ bus_number, from, to, trips, is_this_bus }] }
 * @param {boolean}  isOtherDuty 応援に入った先での交代か（車号ページのみ）
 * @param {node}     lead        見出しの文。省略すると車号ページの言い回しになる
 */
export default function VehicleChange({ change, dutyCode, dutyId, isOtherDuty = false, lead, serviceDate, depot, navigate }) {
  if (!change) return null;

  return (
    <div className="anl-notice anl-notice--change">
      <div style={{ marginBottom: ".375rem" }}>
        {lead ?? (
          <>
            <strong>車両交代</strong> — 乗番
            <button
              className="anl-link"
              style={{ fontWeight: 700 }}
              onClick={() => navigate(`/analysis/duties/${dutyId}`)}
            >
              {dutyCode}
            </button>
            {isOtherDuty ? "（応援に入った先）" : ""}において、当日途中で車両が交代しています。
          </>
        )}
      </div>
      <div className="anl-handover">
        {change.segments.map((s, i) => (
          <React.Fragment key={`${s.bus_number}-${s.from}`}>
            {i > 0 && <span className="anl-handover__arrow" aria-hidden="true" />}
            <span className={`anl-handover__seg${s.is_this_bus ? " anl-handover__seg--self" : ""}`}>
              {s.is_this_bus ? (
                <strong>{s.bus_number}</strong>
              ) : (
                <button
                  className="anl-link"
                  onClick={() =>
                    navigate(`/analysis/buses/${encodeURIComponent(s.bus_number)}?date=${serviceDate}&depot=${encodeURIComponent(depot)}`)
                  }
                >
                  {s.bus_number}
                </button>
              )}
              <span className="anl-handover__span">
                {s.from}〜{s.to} · {s.trips}便
              </span>
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
